import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../../Actions/Config'
import AOS from "aos";
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import {
    Man,
    Mileage,
    Doller
} from "../../Images"
import { getRentCarList } from "../../Actions/TourAction"
import "aos/dist/aos.css";

const mapStateToProps = (state) => {
    return {
        reducer: state.Tour
    }
}

const mapDispatchToProps = dispatch => ({
    getRentCarList: () => dispatch(getRentCarList())
});


function getURL(tour) {
    var url = ""
    switch (tour.tour) {
        case "Day tour":
            url = "/day-tours/" + tour.permalink + "/" + tour.id
            break;
        case "Round tour":
            url = "/round-tours/" + tour.itinerary_category.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') + "/" + tour.permalink
            break;

        case "Excursion":
            url = "/things-to-do/" + tour.permalink
            break;

        case "Rent Vehicle":
            url = "/transport/" + tour.permalink
            break;

        default:
            break;
    }
    return url
}


function getBackgroudImage(tour) {
    var image = ""
    switch (tour.tour) {
        case "Day tour":
            image = tour.listing_image != undefined && tour.listing_image != '' ? tour.listing_image : API_URL + tour.banner_image
            break;
        case "Round tour":
            image = tour.home_image != undefined && tour.home_image != '' ? API_URL + tour.home_image : API_URL + tour.itinerary_images.thumb
            break;
        case "Maldive tour":
            image = tour.home_image.thumb
            break;
        case "Excursion":
            image = API_URL + "/" + tour.image
            break;
        case "Rent Vehicle":
            image = API_URL + "/" + tour.package_thumbnail
            break;
        default:
            break;
    }
    return image
}

class RentCarListing extends Component {

    constructor(props) {
        super(props);

        var typingTimer = null;

        this.state = {

        }
        this.props.getRentCarList()
    }

    componentDidMount() {

        AOS.init({
            duration: 800,
            once: true
        });

        window.scrollTo(0, 0)
        window.addEventListener("scroll", this.handleScroll)
    }

    render() {

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />

            

            <div id="loadDayTour" style={{ backgroundColor: "#f8f8f8" }}>
                <div id="myDiv">
                    <div className="page-title">
                        <div className="container title-cont">
                            <div className="row">
                                <div className="col-lg-12 title-inner">
                                    <div className="breadcrumb-links">
                                        <a href="/">Home</a>   <span className="sep"></span> Rent a Car Packages
                                    </div>
                                    <h1 id="tour-title">Rent a Car Packages</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="maindiv rent-car" >
                        <div className="container">
                            <div className="row">
                                {this.props.reducer.cars.length > 0 ? this.props.reducer.cars.map((car, index) => (<a className="col-lg-3 col-md-3 col-sm-6 col-xs-6 col-po-12" href={getURL(car)} data-aos="fade-up" data-aos-delay={(this.props.index % 4) * 150} data-aos-id={this.props.index}>
                                    <div>
                                        <div className="car-lis" >
                                            <img src={getBackgroudImage(car)} className="car-image" />

                                            <div className="pack-name">
                                                <h5> {car.name}</h5>
                                                <p>{car.vehicle_type != undefined ? car.vehicle_type.type : null}</p>
                                            </div>

                                            <div className="car-lis-det">
                                                <img src={Man} width="16" height="17" />
                                                <div>
                                                    <h5>Number of People</h5>
                                                    <p>{car.vehicle_type != undefined ? car.vehicle_type.max_passengers : null} Pax</p>
                                                </div>
                                            </div>
                                            <div className="car-lis-det mis-allo">
                                                <img src={Mileage} width="21" height="19" />
                                                <div>
                                                    <h5>Mileage Allocation</h5>
                                                    <p>{car.allocated_mileage} Km</p>
                                                </div>
                                            </div>
                                            <div className="car-lis-det mis-allo">
                                                <img src={Doller} width="18" height="19" />
                                                <div>
                                                    <h5>Cost Per Day</h5>
                                                    <p>USD {car.cost_per_day}</p>
                                                </div>
                                            </div>
                                            <span className="right-dth"></span>
                                        </div>
                                    </div>
                                </a>))
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer hyperLink={true}/>
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(RentCarListing);